import { SatelliteDishIcon, WifiHighIcon } from "lucide-react";

export const SkopaStatus = () => {
  return (
    <div className="flex items-center">
      <div className="grow">
        <h4 className="text-sm">Status</h4>
        <p className="text-muted-foreground text-xs">System Passive</p>
      </div>
      <div>
        <SatelliteDishIcon className="size-4.5 text-lime-500" />
      </div>
    </div>
  );
};
